module.exports = require("./xog.d.ts");